import useSearchAllProducts from './useSearchAllProducts'
export default useSearchAllProducts
